import { render, staticRenderFns } from "./StudentTransferSave.vue?vue&type=template&id=159cadf4&"
import script from "./StudentTransferSave.vue?vue&type=script&lang=js&"
export * from "./StudentTransferSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports